var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var isValidDate = function (d) {
    return d instanceof Date && !isNaN(d);
};
export var convertToDate = function (date, language, isMain, showSeconds, timeZone) {
    if (timeZone === void 0) { timeZone = undefined; }
    var newDate = new Date(date);
    if (!newDate || !isValidDate(newDate) || !date)
        return isMain ? '' : ['', ''];
    var formatDate = function (date, options) {
        return new Intl.DateTimeFormat(language === 'ru' ? 'ru-RU' : 'en-US', __assign(__assign({}, options), (timeZone && { timeZone: timeZone }))).format(date);
    };
    var dateOptions = { day: 'numeric', month: 'long' };
    var timeOptions = showSeconds ? { hour: '2-digit', minute: '2-digit', second: '2-digit' } : { hour: '2-digit', minute: '2-digit' };
    var dayMonth = formatDate(newDate, dateOptions);
    var time = formatDate(newDate, timeOptions);
    if (isMain)
        return "".concat(dayMonth, ", ").concat(time);
    var _a = dayMonth.split(' '), day = _a[0], month = _a[1];
    return ["".concat(day, " ").concat(month), time];
};
//# sourceMappingURL=convertToDate.js.mapvar __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var isValidDate = function (d) {
    return d instanceof Date && !isNaN(d);
};
export var convertToDate = function (date, language, isMain, showSeconds, timeZone) {
    if (timeZone === void 0) { timeZone = undefined; }
    var newDate = new Date(date);
    if (!newDate || !isValidDate(newDate) || !date)
        return isMain ? '' : ['', ''];
    var formatDate = function (date, options) {
        return new Intl.DateTimeFormat(language === 'ru' ? 'ru-RU' : 'en-US', __assign(__assign({}, options), (timeZone && { timeZone: timeZone }))).format(date);
    };
    var dateOptions = { day: 'numeric', month: 'long' };
    var timeOptions = showSeconds ? { hour: '2-digit', minute: '2-digit', second: '2-digit' } : { hour: '2-digit', minute: '2-digit' };
    var dayMonth = formatDate(newDate, dateOptions);
    var time = formatDate(newDate, timeOptions);
    if (isMain)
        return "".concat(dayMonth, ", ").concat(time);
    var _a = dayMonth.split(' '), day = _a[0], month = _a[1];
    return ["".concat(day, " ").concat(month), time];
};
//# sourceMappingURL=convertToDate.js.map